function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("励志成为阿帕奇在逃开发，如你们所见，我是个男的，期望我们混熟了以后，你们还能记得我是个男的。")]),_vm._v(" "),_c('h3',[_vm._v("未知年份中国制造，长172cm。采用人工智能，各部分零件齐全，运转稳定，经二十多年的运行，属质量信得过产品。该“产品”手续齐全，无限期包退包换。现因发展需要，诚招志同道合者，共同研制开发第四代语言聊天软件，有意者请联系！")]),_vm._v(" "),_c('p',[_vm._v("做这个网站的主要目的一方面是能够将工作中遇到的新技术运用上，不管是前端那些漂亮的组件界面等， 另一方面是，能够将工作中遇到的问题和心得记在这个网站上，虽然现在有很多这样的工具\n，但是能够记录到自己开发的网站上，也是别有一番风味。")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"https://www.duanqing.online:9000/blog/444.jpg","alt":""}})])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }